"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slugCreator = exports.getWindowSize = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
/* istanbul ignore file */

const getWindowSize = () => {
  const isClient = typeof window === 'object';
  const lastWidth = (0, _react.useRef)();
  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined
    };
  }
  const [windowSize, setWindowSize] = (0, _react.useState)(getSize);
  (0, _react.useEffect)(() => {
    if (!isClient) {
      return false;
    }
    function handleResize() {
      var _window;
      if (((_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth) !== lastWidth.current) {
        const width = getSize();
        lastWidth.current = width;
        setWindowSize(width);
      }
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
};
exports.getWindowSize = getWindowSize;
const slugCreator = title => {
  return title.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
};
exports.slugCreator = slugCreator;